import { Layout } from 'antd';
import { GroupedExpert } from '@/feed/components/grouped-expert';

export const OptionsView = () => {
  return (
    <Layout.Content className="container min-h-full">
      <GroupedExpert />
    </Layout.Content>
  );
};
